import { gql } from '@apollo/client'

export const GET_CURRENT_USER = gql`
    query GetSidebarUser($where: UserWhere) {
        users(where: $where) {
            id
            email
            firstName
            lastName
        }
    }
`

export const GET_PENDING_APPROVALS = gql`
    query GetPendingApprovals($limit: Int, $page: Int) {
        getAllUsers(limit: $limit, page: $page) {
            id
            onboarding
        }
    }
`

